<template>
<main-content>
    <kt-panel>
        <kt-panel-body>
            <kt-row>
                <kt-col xs="12" md="6">
                    <ivr-info :ivr="form_data"></ivr-info>
                </kt-col>
                <kt-col xs="12" md="6">
                    <gateway-statistics></gateway-statistics>
                    <ivr-setting></ivr-setting>
                </kt-col>
            </kt-row>
        </kt-panel-body>
    </kt-panel>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import { mapGetters } from 'vuex'
import { ivrSetting, ivrInfo } from './components'
import gatewayStatistics from './components/gateway-statistics'

export default {
    components: {
        mainContent,
        ivrSetting,
        ivrInfo,
        'gateway-statistics': gatewayStatistics
    },
    computed: {
        ...mapGetters('ivr', [
            'form_data', 'status'
        ]),
    },
    data() {
        return {
            'hashid': this.$route.params.hashid,
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
                vm.$store.dispatch('ivr/find', vm.hashid)
        })
    },
}
</script>

<style>
@media (min-width: 768px) {
    #ivr-info > div > :first-child {
        border-left: 1px solid #ddd;
    }
}
</style>